<template>
  <div :class="{'custom-gray-styles': !is_invitation_link}">
    <div v-if="is_mexican === null">
      <component :is="is_invitation_link ? 'h3' : 'h2'" class="text-center">
        {{ $t('dashboard.uploadReceive') }}
      </component>

      <p class="avenir-medium mb-2" :class="is_invitation_link ? 'text-justify' : 'text-center'">{{ $t('dashboard.ifYouAreCreator') }}</p>

      <b-button class="button-upload-invoice mb-2" @click="is_mexican = true;" id="2">
        <strong class=""><b-icon icon="file-earmark-text"></b-icon> {{ $t('dashboard.receiveMexico') }}</strong>
        <p class="avenir-medium mb-0">{{ $t('dashboard.receiveMexicoInfo') }}</p>
      </b-button> 
      <b-button class="button-upload-invoice" @click="is_mexican = false">
        <strong class=""><b-icon icon="file-earmark-text"></b-icon> {{ $t('dashboard.receiveInternational') }}</strong>
        <p class="avenir-medium mb-0">{{ $t('dashboard.receiveInternationalInfo') }}</p>
      </b-button>
    </div>
    <feather-icon icon="ArrowLeftIcon" size="20" class="cursor-pointer" @click="is_mexican = file_pdf = file_xml = null; " v-if="is_mexican !== null"></feather-icon>

    <!-- National form -->
    <div v-if="is_mexican">
      <component :is="is_invitation_link ? 'h3' : 'h2'" class="text-center">{{ $t('dashboard.incoiceMexican') }}</component>
      <p :class="`avenir-medium mb-2 white-space-pre-line ${is_invitation_link ? 'text-justify' : 'text-center'}`">{{ $t('dashboard.pleaseInclude') }}</p>

      <input-drag-and-drop-file 
        :data="{
          extensions_allowed: '.pdf', 
          icon: {type: 'b-icon', name: 'file-earmark-text'}, 
          title: $t('dashboard.invoicePdf'), 
          subtitle: $t('dashboard.invoicePdfUpload')
        }"
        @file_loaded="fileLoaded"
        class="mb-2"
      ></input-drag-and-drop-file>

      <input-drag-and-drop-file 
        :data="{
          extensions_allowed: '.xml', 
          icon: {type: 'b-icon', name: 'file-earmark-text'}, 
          title: 'XML', 
          subtitle: $t('dashboard.invoiceCSV')
        }"
        @file_loaded="fileLoadedXml"
        class="mb-2"
      ></input-drag-and-drop-file>
    </div>

    <!-- International form -->
    <div v-else-if="is_mexican === false" class="mb-">
      <component :is="is_invitation_link ? 'h3' : 'h2'" class="text-center">{{ $t('dashboard.incoiceMexican') }}</component>
      <div :class="`avenir-medium ${is_invitation_link ? 'text-justify' : 'text-center'}`">
        <p class="mb-2 white-space-pre-line">{{ $t('dashboard.loadInvoiceInternational0') }}</p>
        <p class="mb-2 white-space-pre-line">{{ $t('dashboard.loadInvoiceInternational1') }}</p>
        <p class="mb-2 white-space-pre-line">{{ $t('dashboard.loadInvoiceInternational2') }}</p>
        <p class="mb-0 white-space-pre-line">BRANDME CROWDMARKETING SAPI DE CV</p>
        <p class="mb-0 white-space-pre-line">BCR130924V68</p>
        <p class="mb-0 white-space-pre-line">TONALA 10, COLONIA ROMA NORTE, CDMX</p>
        <p class="mb-2 white-space-pre-line">CP06700, MEXICO </p>
        <p class="mb-2 white-space-pre-line">{{ $t('dashboard.loadInvoiceInternational3') }} <a :href="`${host}/assets/brandme_invoice_international.pdf?v=1745353694`" target="_blank">este ejemplo</a>{{ $t('dashboard.loadInvoiceInternational3_1') }} <a @click="downloadFile(`${host}/assets/brandme_template_invoice.xlsx?v=1745353694`)">dando clic aquí.</a></p>
        <p class="mb-2 white-space-pre-line">{{ $t('dashboard.loadInvoiceInternational4') }}</p>
      </div>

      <input-drag-and-drop-file 
        :data="{
          extensions_allowed: '.pdf', 
          icon: {type: 'b-icon', name: 'file-earmark-text'}, 
          title: $t('dashboard.uploadInvoiceInternational'), 
          subtitle: $t('dashboard.uploadInvoiceInternationalInfo')
        }"
        @file_loaded="fileLoaded"
        class="mb-2"
      ></input-drag-and-drop-file>
    </div>
    <b-button variant="blue-button" class="blue-button w-100" :disabled="handle_disabled" v-if="is_mexican !== null" @click="requestMoney">{{ $t(`dashboard.${!is_invitation_link ? 'loadInvoice' : 'collectMoney'}`) }}</b-button>
  </div>
</template>
    
<script>
import { 
  BButton,
  BFormFile,
  BAvatar,
} from "bootstrap-vue";
import { requestBalance } from '@/services/finance';
import { downloadFile, showToast } from "@/libs/utils/others";
import service_invitation from '@/services/invitation';

export default {
  name: "uploadReceives",
  components: {
    BButton,
    BFormFile,
    BAvatar,
    inputDragAndDropFile: () => import('@/views/components/inputs/inputDragAndDropFile.vue')
  },
  data() {
    return {
      is_mexican: null,
      file_pdf: null,
      file_xml: null,
      host: window.location.origin,
      downloadFile
    };
  },
  props: {
    transactions_ready_withdraw: {
      type: Array,
      default: () => {
        return []
      }
    },
    is_invitation_link: {
      type: Boolean,
      default: false,
    },
    is_ready_to_pay_invitation: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    handle_disabled() {
      const invitation_status = this.is_invitation_link ? this.is_ready_to_pay_invitation : true;
      if (this.is_mexican) {
        return (this.file_pdf === null || this.file_xml === null) || !invitation_status;
      } else {
        return (this.file_pdf === null || !invitation_status);
      }
    }
  },
  methods: {
    fileLoaded(file) {
      this.file_pdf = file;
    },
    fileLoadedXml(file) {
      this.file_xml = file;
    },
    handleValidateTypes() {
      const accepted_types = ['pdf', 'xml'];
      const files = [this.file_pdf.type.split('/')[1]];      
      if (this.is_mexican) {
        files.push(this.file_xml.type.split('/')[1]);
      }
   
      return files.every(type => accepted_types.includes(type));
    },
    openFileInput() {
      setTimeout(() => {
        this.$refs['input-file-invoice'].$refs['input'].click()
      }, 20);
    },
    requestMoneyInvitation() {
      const { slug, username, network} = this.$route.params;
      const form_data = new FormData();
      if (this.is_mexican) form_data.append('xml_file', this.file_xml)
      form_data.append('tax_file', this.file_pdf)
      form_data.append('slug_campaign', slug);
      form_data.append('username', username);
      form_data.append('network', network);

      service_invitation.requestMoneyInvitation(form_data).then((response) => {
        if (response.status >= 400) {
          showToast(this, 'danger', 'XIcon', 'search.check_influencer_title', 'creator.noTransactionSucccess');
          return;
        }
        showToast(this, 'success', 'DollarSignIcon', 'creator.requestCollect', 'creator.yourRequest');
        this.$emit('update_campaign_status');
      })
    },
    requestMoney() {
      if (this.handleValidateTypes()) {

        if (this.is_invitation_link) {
          this.requestMoneyInvitation();
          return;
        }
        const form_data = new FormData();
        this.transactions_ready_withdraw.forEach(i => {
          form_data.append('transactions_uuid', i)
        });
        if (this.is_mexican) form_data.append('xml_file', this.file_xml)
        form_data.append('tax_file', this.file_pdf)

        requestBalance(form_data).then((response) => {
          if (response.status === 'OK') {
            this.$emit('update_transaction')

            showToast(this, 'success', 'DollarSignIcon', 'creator.requestCollect', 'creator.yourRequest');
          } else {
            showToast(this, 'danger', 'XIcon', 'Error', response.data.response.message, {translate_text: false, translate_title: false});
          }
        }).catch(() => {
          showToast(this, 'danger', 'XIcon', 'search.check_influencer_title', 'creator.noTransactionSucccess');
        })
      } else {
        showToast(this, 'danger', 'XIcon', 'Error', 'dashboard.invalidType', {translate_title: false});
      }
    },
  },
};
</script>
<style lang="scss">
.button-upload-invoice {
  background-color: white !important;
  padding: 1rem !important;
  color: #444050 !important;
  box-shadow: none !important;
  border-color: #d3d3d4 !important;
  text-align: left !important;
  width: 100%;
  &:focus {
    background-color: white !important;
    outline: 2px solid #0096fe;
  }
  strong {
    display: block;
    margin-bottom: 0.7em;
  }
  p {
    font-size: 13px;
    margin-left: 1.3rem;
  }
}
</style>
<style lang="scss" scoped>
.white-space-pre-line {
  white-space: pre-line;
}
p {
  color: #6d6b77;
}
h2 {
  color: #444050 !important;
}

a {
  color: #0096fe !important;
}
</style>